import React from "react";
import { connect } from "react-redux";
import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";
import axios from "../../axios-atis";
import { Button, Col, FormControl, Row } from "react-bootstrap";
import Contact from "./Contact";
import { isA, isReporter } from "../../store/utility";
import Switch from "rc-switch";
import Loader from "react-loader-spinner";
import {
  fetchCompanies,
} from "../../store/actions/index";

class Contacts extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      loading:false,
      backupData: null,
      rowId: null,
      editingId: null,
      addContact: false,
      displayDeleted: false,
      conceptLoaded: false,
      selectedCompany: "all",
    };
    this.props.dispatch(fetchCompanies());
  }

  //LifeCycle
  componentWillReceiveProps(nextProps) {
    if (this.props.data !== nextProps.data) {
      this.setState({
        data: nextProps.data,
        backupData: nextProps.data,
      });
    }
  }
  addContactHandler = (event) => {
    event.preventDefault();
    var _state = this.state;
    _state.addContact = true;
    this.setState(_state);
  };

  hideContactHandler = (event) => {
    event.preventDefault();
    var _state = this.state;
    _state.addContact = false;
    this.setState(_state);
  };
  //UI methods

  saveOrUpdate = (contact) => {
    this.props.saveOrUpdate(contact);
    var _state = this.state;
    _state.addContact = false;
    _state.editingId = null;
    this.setState(_state);
  };
  
  changeDisplayInputHandler = (value) => {
    this.setState({ displayDeleted: value });
  };
  
  buildRows = (editingId) => {
    const { selectedCompany } = this.state;
    let { data } = this.props;

    if ( selectedCompany !== "all" ) {
      data = data.filter((c) =>  c.company.id == selectedCompany);
    } 
    var companyContacts = [];

    for (var i = 0; i < data.length; i++) {
      var element = data[i];
      var objectAlreadyExists = false;
      for (var j = 0; j < companyContacts.length; j++) {
        //if (companyContacts[j].company.id === element.company.id) {
          if (companyContacts[j].company.id === element.company.id) {
          companyContacts[j].contacts.push(element);
          objectAlreadyExists = true;
          break;
        }
      }
      if (!objectAlreadyExists) {
        var contacts = [];
        contacts.push(element);
        companyContacts.push({ company: element.company, contacts: contacts });
      }
    }
    
    var rows = [];
    companyContacts.sort((a, b) => {
      /*if (a == null || a.company == null || a.company.name == null) {
        return -1
      } else if (b == null || b.company == null || b.company.name == null) {
        return 1;
      } else {
        return a.company.name.trim().localeCompare(b.company.name.trim(), "fr-FR");
      }*/
      if (a == null || a.company == null) {
        return -1
      } else if (b == null || b.company == null) {
        return 1;
      } else {
        return a.company.name.trim().localeCompare(b.company.name.trim(), "fr-FR");
      }
    });
      

    for (var k = 0; k < companyContacts.length; k++) {
      if (companyContacts.length > 1) {
        rows.push(
          <h5 key={k} style={{ borderBottom: "2px solid #efefef" }}>
            {//companyContacts[k].company.name
            companyContacts[k].company.name.trim()}
          </h5>
        );
      }
      var l = 0;
      var nbCols = 0;
      companyContacts[k].contacts.sort((a, b) =>
        a.enabled === null
          ? -1
          : b.enabled === null
          ? 1
          : a.enabled === b.enabled
          ? a.email.localeCompare(b.email)
          : a.enabled
          ? -1
          : b.enabled
          ? 1
          : 0
      );

      var dispContacts = companyContacts[k].contacts;
      if (!this.state.displayDeleted) {
        dispContacts = companyContacts[k].contacts.filter(function (contact) {
          return contact.enabled;
        });
      }

      let nbContacts = dispContacts.length;
      while (nbCols < nbContacts) {
        //console.log(dispContacts[l]);
        rows.push(
          <Row key={(k + 1) * 1024 + l}>
            <Col sm={4}>
              {l < nbContacts ? (
                <Contact
                  data={dispContacts[l]}
                  editing={editingId === dispContacts[l].id}
                  disableOthersEditing={this.disableOthersEditing}
                  saveOrUpdate={(contact) => this.saveOrUpdate(contact)}
                />
              ) : null}
            </Col>
            <Col sm={4}>
              {l + 1 < nbContacts ? (
                <Contact
                  data={dispContacts[l + 1]}
                  editing={editingId === dispContacts[l + 1].id}
                  disableOthersEditing={this.disableOthersEditing}
                  saveOrUpdate={(contact) => this.saveOrUpdate(contact)}
                />
              ) : null}
            </Col>
            <Col sm={4}>
              {l + 2 < nbContacts ? (
                <Contact
                  data={dispContacts[l + 2]}
                  editing={editingId === dispContacts[l + 2].id}
                  disableOthersEditing={this.disableOthersEditing}
                  saveOrUpdate={(contact) => this.saveOrUpdate(contact)}
                />
              ) : null}
            </Col>
          </Row>
        );
        nbCols += l + 2 < nbContacts - 1 ? 3 : l + 1 < nbContacts - 1 ? 2 : 1;
        if (l + 3 < nbContacts) {
          l += 3;
        } else {
          l += nbContacts - l;
        }
      }
    }
    //this.setState({ conceptLoaded: true });

    return rows;
  };

  disableOthersEditing = (id) => {
    this.setState({ editingId: id });
    this.forceUpdate();
  };

  changeCompany = (event) => {
    this.setState({selectedCompany: event.target.value});
  }

  render() {
    const { data, company, loading, companies } = this.props;
    if (data === null || company === null || loading) {
      return (<div align="center">
        <Loader type="ThreeDots" color="#00BFFF" height="100" width="100" />
      </div>);
    }
    const editingId = this.state.editingId;
    const rows = this.buildRows(editingId);
    
    var newContact = {
      id: null,
      name: "",
      forname: "",
      email: "",
      cellular: "",
      phone: "",
      enabled: "true",
      byDefault: "false",
    };
    if (!isA() && !isReporter()) {
      newContact.company = this.props.companies[0];
    }

    return (
      <div>
        { isA() || isReporter() ? (
        <Row style={{marginBottom: '20px'}}>
          <Col sm={12}>
            <FormControl componentClass="select" onChange={this.changeCompany} value={this.state.selectedCompany}>
              <option value="all">Afficher tout</option>
              {null !==  companies ? companies.map(function(item, index) {
              return (
                <option key={index} value={item == null ? "" : item.id}>
                  {item == null ? "" : item.label || item.name.trim()}
                </option>
              );
            })
            : ""}
            </FormControl>
          </Col>
        </Row>) : null}
        <Row>
          <Col xsHidden sm={12} style={{ display: 'flex', alignItems: 'center', justifyItems: 'flex-end', flexDirection: 'row-reverse' }}>
            <Button 
              bsStyle="primary"
              bsSize="sm"
              className="pull-right"
              style={{ marginLeft: '10px' }}
              onClick={(event) => this.addContactHandler(event)}
            >
              <span className="fa fa-plus" />
              &nbsp;Nouveau Contact
            </Button>
            <div className="pull-right" >
              Afficher les contacts supprimés{" "}
              <Switch
                checked={this.state.displayDeleted}
                onChange={(event) => this.changeDisplayInputHandler(event)}
              />
            </div>
          </Col>
          <Col smHidden mdHidden lgHidden  xs={12}>
              Afficher les contacts supprimés{" "}
              <Switch
                checked={this.state.displayDeleted}
                onChange={(event) => this.changeDisplayInputHandler(event)}
              />
            </Col>
          <Col smHidden mdHidden lgHidden xs={12}>
            <Button 
              bsStyle="primary"
              style={{ width: '100%' }}
              onClick={(event) => this.addContactHandler(event)}
            >
              <span className="fa fa-plus" />
              &nbsp;Nouveau Contact
            </Button>
            
          </Col>
        </Row>

        {this.state.addContact ? (
          <Row>
            <Col sm={3} />
            <Col sm={6}>
            <Contact
                data={newContact}
                editing={true}
                company={this.props.company}
                companies={this.props.companies}
                disableOthersEditing={this.disableOthersEditing}
                saveOrUpdate={(contact) => this.saveOrUpdate(contact)}
                hideContact={this.hideContactHandler}
              />
            </Col>
            <Col sm={3} />
          </Row>
        ) : null}
        {rows}
        
      </div>
    );
  }
}
//export default Contacts;

const mapStateToProps = (state) => {
  return {
    loading: state.companies,
    isAuthenticated: state.auth.token !== null,
    companies: state.company.companies,
  };
};

export default connect(mapStateToProps)(withErrorHandler(Contacts, axios));



// WEBPACK FOOTER //
// ./src/containers/Contact/Contacts.js